import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {tagTypeAction, HttpStatusCodes} from '../../util/uiconstants';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      storeIgua.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function clientRequestTagsReducer(state = initialState.clientRequestTags, action) {
	switch (action.type) {
		case types.GET_CLIENT_REQUEST_TAGS: {
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				// group by ey-created and client-created.
				const groupedTags = action.response.data.reduce(
					(result, tag) => {
						tag.isClientCreated ? result.ccp.push(tag) : result.ey.push(tag);
						tag.action = tagTypeAction.existing;
						return result;
					},
					{ccp: [], ey: []}
				);
				return [...groupedTags.ey, ...groupedTags.ccp];
			}
			return state;
		}
		case types.CLEAN_CLIENT_REQUEST_TAGS: {
			return [];
		}
		case types.CREATE_CLIENT_REQUEST_TAG: {
			return state;
		}
		case types.EDIT_CLIENT_REQUEST_TAG: {
			return state;
		}
		case types.DELETE_CLIENT_REQUEST_TAG: {
			return state;
		}
		default:
			return state;
	}
}
